var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-message',{attrs:{"message":_vm.message,"messageProp":_vm.messageProp},on:{"messageClose":_vm.messageClose}})}
var staticRenderFns = []

export { render, staticRenderFns }